(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["advertorial-flow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('adv-check')) {
    customElements.define('adv-check', class extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('[data-check-item]'));
        this.items.forEach((btn) => btn.addEventListener('click', () => {
          btn.setAttribute('aria-pressed', btn.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
          this.update();
        }));
      }
      update() {
        const n = this.items.filter((b) => b.getAttribute('aria-pressed') === 'true').length;
        const total = this.items.length;
        const tpl = n === 0 ? this.dataset.zero : n === 1 ? this.dataset.one : this.dataset.many;
        this.querySelector('[data-check-count]').textContent = n;
        this.querySelector('[data-check-result]').textContent = (tpl || '').split('[n]').join(n).split('[total]').join(total);
        const cta = this.querySelector('[data-check-cta]');
        if (cta) cta.hidden = n === 0;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('announcement-bar')) {
    customElements.define('announcement-bar', class extends HTMLElement {
      connectedCallback() {
        this.msgs = [...this.querySelectorAll('.ab__msg')];
        this.index = 0;
        const interval = parseInt(this.dataset.interval, 10) || 5000;
        if (this.msgs.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.timer = setInterval(() => this.show(this.index + 1), interval);
        this.addEventListener('mouseenter', () => { this.paused = true; });
        this.addEventListener('mouseleave', () => { this.paused = false; });
      }
      disconnectedCallback() { clearInterval(this.timer); }
      show(i) {
        if (this.paused) return;
        this.msgs[this.index].classList.remove('is-active');
        this.msgs[this.index].setAttribute('aria-hidden', 'true');
        this.index = i % this.msgs.length;
        this.msgs[this.index].classList.add('is-active');
        this.msgs[this.index].removeAttribute('aria-hidden');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["journal-article"]) return;
  try {
    
  (function () {
    /* Builds the table of contents from the article's H2 headings and gives each heading an anchor. */
    const body = document.querySelector('[data-article-body]');
    const toc = document.querySelector('[data-toc]');
    if (!body || !toc) return;
    const heads = Array.from(body.querySelectorAll('h2'));
    if (heads.length < 2) return;
    const list = toc.querySelector('[data-toc-list]');
    const used = {};
    heads.forEach((h) => {
      let id = h.id || h.textContent.trim().toLowerCase()
        .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue')
        .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'abschnitt';
      if (used[id]) id += '-' + (++used[id]); else used[id] = 1;
      h.id = id;
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = '#' + id;
      a.textContent = h.textContent.trim();
      li.appendChild(a);
      list.appendChild(li);
    });
    toc.hidden = false;
  })();

  } catch(e) { console.error(e); }
})();
})();
